var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOnlyfans(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9178_31891)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.05657 4C9.09585 4 10.1247 4.2065 11.0847 4.60783C12.0447 5.00917 12.9171 5.59727 13.6517 6.33898C14.3867 7.08039 14.9693 7.96076 15.3672 8.92988C15.7649 9.89908 15.9696 10.9375 15.9696 11.9861C15.9696 15.2162 14.0416 18.128 11.0847 19.364C8.12783 20.6 4.72434 19.9169 2.46138 17.6329C0.198427 15.3489 -0.478589 11.9141 0.745979 8.92988C1.97084 5.94572 4.85618 4 8.05657 4ZM8.05657 14.3815C8.36835 14.3818 8.67716 14.3203 8.96549 14.2001C9.25381 14.08 9.51542 13.9034 9.73604 13.6808C9.95667 13.4581 10.1313 13.194 10.2506 12.9032C10.3698 12.6122 10.4309 12.3005 10.4306 11.9858C10.4306 11.0167 9.85214 10.1432 8.96519 9.7723C8.07824 9.40145 7.05708 9.60645 6.37828 10.2917C5.69948 10.9769 5.49638 12.0073 5.86369 12.9026C6.231 13.7979 7.09687 14.3815 8.05686 14.3815H8.05657Z",
    fill: "#00AEEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9508 9.9895C18.9613 10.5734 21.3345 9.9895 21.3345 9.9895C20.6459 13.0242 18.4616 14.9248 15.3123 15.1561C15.0087 15.8674 14.6038 16.5304 14.1103 17.1242C13.6172 17.7175 13.0409 18.2352 12.3993 18.6611C11.758 19.0866 11.0587 19.4157 10.3232 19.6377C9.58765 19.8597 8.82422 19.9721 8.05664 19.9718L10.4307 12.3572C12.8709 4.53038 14.1219 4.00024 19.9092 4.00024H23.8828C23.2182 6.95513 20.9271 9.21223 16.9511 9.9895H16.9508Z",
    fill: "#008CCF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9178_31891"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 16,
    fill: "white",
    transform: "translate(0 4)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnlyfans);
export default __webpack_public_path__ + "static/media/onlyfans.a03994032684bda23d4b7e071bc2ba7d.svg";
export { ForwardRef as ReactComponent };